import axiosInstance from "../axios/axiosInstance";

export interface DiscordStats {
  totalMembers: number;
  onlineMembers: number;
}

export const getDiscordStats = async (): Promise<DiscordStats> => {
  try {
    const response = await axiosInstance.get("/discord/stats");
    const { totalMembers, onlineMembers } = response.data;

    return {
      totalMembers,
      onlineMembers,
    };
  } catch (error) {
    console.log(error);
    throw error;
  }
};
